// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"68":"ad598ff3","173":"55d0e761","2547":"d71ade29","2796":"ad598ff3","9055":"1f3611d7","9972":"65326d44"}[chunkId] + ".chunk.css";
};